import { render } from "./AllAppointmentDoctors.vue?vue&type=template&id=d08227be&scoped=true"
import script from "./AllAppointmentDoctors.vue?vue&type=script&lang=js"
export * from "./AllAppointmentDoctors.vue?vue&type=script&lang=js"

import "./AllAppointmentDoctors.vue?vue&type=style&index=0&id=d08227be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d08227be"]])

export default __exports__